import styled from 'styled-components';

export default styled.div`
  text-align: ${props => {
    if (props.left) return 'left';
    else if (props.right) return 'right';
    return 'center';
  }};
`;
